import React from "react"

import Image from "next/image"
import Link from "next/link"

import { Article } from "@/interface"
import { svgs } from "public/assets/svgs"

interface AnimatedButtonProps {
  label: string
  onClick?: () => void
}

const AnimatedButton = ({ label, onClick }: AnimatedButtonProps) => {
  return (
    <button className="group cursor-pointer py-1 font-medium" onClick={onClick}>
      <div className="relative overflow-hidden">
        <p className="duration-1000 ease-&lsqb;cubic-bezier(0.19,1,0.22,1)&rsqb; underline group-hover:-translate-y-7">{label}</p>
        <p className="ease-&lsqb;cubic-bezier(0.19,1,0.22,1)&rsqb; absolute left-0 top-7 underline group-hover:top-0">
          {label}
        </p>
      </div>
    </button>
  )
}

const BlogCard: React.FC<{ articles: Article[]; customClassName?: string }> = ({ articles, customClassName }) => {
  return articles?.length > 0 ? (
    articles.map((post) => {
      const date = new Date(post?.publishedAt)
      const formattedDate = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })

      return (
        <Link
          href={`/blog/${post?.slug}`}
          key={post?.slug}
          className={`${customClassName} flex w-full flex-col gap-4 bg-transparent md:gap-[21.5px] md:rounded-xl`}
        >
          <div className="flex h-full flex-col gap-4">
            {post?.cover?.url ? (
              <Image
                className="h-[175px] w-full rounded-lg object-cover"
                src={post.cover.url}
                alt={post.title}
                width={2000}
                height={175}
              />
            ) : (
              <div className="h-[175px] w-full rounded-lg bg-[#f5f5f5]"></div>
            )}
            <div className="flex flex-col gap-2">
              <div className="flex gap-2 text-xs tracking-[-1%] text-[#3F3F3FBF]">
                <span>{formattedDate}</span>
                <span className="font-medium">—</span>
                <span className="text-[#FC9132]">{post?.readMinutes} min read</span>
              </div>
              <div className="font-base line-clamp-2 font-medium tracking-[-3%] lg:text-xl">{post?.title}</div>
            </div>
          </div>
          <div className="flex items-center gap-2 text-sm text-[#3F3F3FBF]">
            {/* <span className="font-semibold underline">Read more</span> */}
            <AnimatedButton label="Read more" />
            {svgs["arrowRightIcon"]?.({ fill: "#3F3F3FBF", height: 16, width: 16 })}
          </div>
        </Link>
      )
    })
  ) : (
    <p className="mx-auto p-6 text-center text-gray-500">No blog posts available.</p>
  )
}

export default BlogCard
